import { AbcWeb3Provider } from '~/libs/abc-waas-provider';
import { getSession } from '~/services/auth/authService';
import env from '~/env';
import { RPC_URLS } from '~/config';
import { ethers } from 'ethers';
import Web3Modal from '@colligence/web3modal';

const HelperUtil = {
  getAbcWeb3Provider: async (target: number) => {
    // console.log(`!!!!!!!!!! USE ABC-WEB3-PROVIDER :  ${target} !!!!!!!!!!`);
    window.localStorage.setItem('target', target.toString());

    let provider: any = null;
    const rlt = await getSession();

    if (rlt.data?.providerAuthInfo) {
      // TODO: abc-web3-provider 초기화
      const id_token = rlt.data?.providerAuthInfo?.provider_token;
      const service = rlt.data?.providerAuthInfo?.provider;
      const data = JSON.parse(rlt.data?.providerAuthInfo?.provider_data);
      const email =
        service === 'kakao'
          ? data?.kakao_account.email
          : service === 'naver'
          ? data?.response.email
          : data.email;
      console.log('>>>>>>>>>>', service, id_token, email);

      const providerOptions = {
        abc: {
          package: AbcWeb3Provider, //required
          options: {
            bappName: 'web3Modal Example App', //required
            chainId:
              '0x' + (target ?? env.REACT_APP_TARGET_NETWORK_KLAY).toString(16),
            rpcUrl: RPC_URLS[target ?? env.REACT_APP_TARGET_NETWORK_KLAY], //required
            email,
            id_token,
            serv: service,
          },
        },
      };
      const web3Modal = new Web3Modal({ providerOptions });

      // Connect Wallet
      const instance = await web3Modal.connect();

      if (instance) {
        const abcUser = JSON.parse(
          window.localStorage.getItem('abcUser') as string
        );
        // console.log('==========================', abcUser);
        // console.log('=============>', abcUser && abcUser?.accounts ? abcUser?.accounts[0].ethAddress : 'No ethAddress');

        provider = new ethers.providers.Web3Provider(instance);
        // await provider.enable();
        const signer = provider.getSigner();
        // console.log('signer=============>', signer);
      }
    }
    return provider;
  },
};

export default HelperUtil;
